export default __webpack_public_path__ + "fonts/title-web.ae19cae5b3f519fbca717a97bfd1e2d2.png";